import React, { useEffect, useState, useRef } from 'react';  
import { useSpring, animated } from 'react-spring';  
import "./Home.scss";  
import { useWallet } from '../src/Context/WalletContext';  
import { Link } from 'react-router-dom';  
import axios from 'axios';  
import Quickstart from './Components/Quickstart';  
import Faq from './Components/Faq';  
import Spaceship1 from './images/portal/spaceship-1.webp';  
import Spaceship2 from './images/portal/spaceship-3.webp';  
import Spaceship3 from './images/portal/spaceship-2.webp';  
import MenuBridge from './images/portal/menu-bridge.webp';  
import MenuExplorer from './images/portal/menu-explorer.webp';  
import MenuFaucet from './images/portal/menu-faucet.webp';  
import MenuConnect from './images/portal/menu-connect.webp';  
import TutorialMainnet from './images/portal/tutorial-mainnet.webp';  
import TutorialFarming from './images/portal/tutorial-farming.webp';  
import CounterTitle from './images/portal/counter-title.png';  
import CounterFrameLeft from './images/portal/counter-frame-left.webp';  
import CounterFrameRight from './images/portal/counter-frame-right.webp';  
import PartnerGamecenter from './images/portal/partner-gamecenter.webp';  
import SwipeBanner1 from './images/portal/swipe-banner-1.webp';  
import SwipeBanner2 from './images/portal/swipe-banner-2.webp';  
import { useTranslate } from 'react-polyglot';  
import { Swiper, SwiperSlide } from 'swiper/react';  
import 'swiper/css';  
import 'swiper/css/pagination';  
import 'swiper/css/navigation';  
import { Autoplay, Navigation } from 'swiper/modules';  
  
function AnimatedNumber({ n }) {  
  const prevN = useRef(n);  
  const { number } = useSpring({  
    from: { number: prevN.current },  
    to: { number: n },  
    config: {  
      duration: 10000,  // Increased duration to 10 seconds  
      easing: t => t * (2 - t),  // Ease-out function for smoother deceleration  
    },  
    onRest: () => {  
      prevN.current = n;  
    },  
  });  
  return <animated.span>{number.to((n) => Math.floor(n).toString())}</animated.span>;  
}  
  
export default function Home() {  
  const t = useTranslate(); // Initialize translation function  
  const { walletAddress, isConnected, connectWallet } = useWallet(); // Use the wallet context  
  const [totalWallets, setTotalWallets] = useState(null);  
  
  useEffect(() => {  
    // Get the hash from the URL  
    const hash = window.location.hash;  
    if (hash) {  
      // Scroll to the element with the corresponding ID  
      const element = document.querySelector(hash);  
      if (element) {  
        element.scrollIntoView({ behavior: 'smooth' });  
      }  
    }  
  }, []);  
  
  // Add this new function for API calls  
  async function sendRequest(data, url, method = "post", params = null) {  
    const config = {  
      method,  
      url,  
      headers: {  
        "Content-Type": "application/json",  
      },  
      data: JSON.stringify(data),  
    };  
    if (params) config.params = params;  
    return await axios.request(config).catch(function (error) {  
      if (error.response) {  
        return error.response;  
      } else {  
        return error;  
      }  
    });  
  }  
  
  const fetchTotalWallets = async () => {  
    try {  
      const response = await sendRequest(  
        { action: "getTotalUsers" },  
        `${process.env.REACT_APP_API_URL}`  
      );  
  
      if (response.status === 200 && response.data) {  
        setTotalWallets(response.data.data);  
      }  
    } catch (error) {  
      console.error("Error fetching total wallets:", error);  
    }  
  };  
  
  useEffect(() => {  
    fetchTotalWallets(); // Initial fetch  
  
    // Set up interval to fetch total wallets every 20 seconds  
    const intervalId = setInterval(fetchTotalWallets, 20000);  
  
    // Clean up interval on component unmount  
    return () => clearInterval(intervalId);  
  }, []);  
  
  const toolsContent = {  
    type: 1,  
    cardname: 'tools',  
    title: 'Tools',  
    descBottom: 'Click here, Do Stuff, And Pretend You\'re A Wizard!',  
    details: [  
      {  
        name: 'Bridge',  
        desc: 'Transfer assets seamlessly',  
        img: MenuBridge,  
        link: 'https://bridge.zkcandy.io/',  
      },  
      {  
        name: 'Explorer',  
        desc: 'View network transactions',  
        img: MenuExplorer,  
        link: 'https://explorer.zkcandy.io/',  
      },  
      {  
        name: 'Passport',  
        desc: 'Manage your asset',  
        img: MenuFaucet,  
        link: 'https://passport.zkcandy.io/',  
      },  
    ],  
    caption: ''  
  };  
  
  const guideContent = {  
    type: 1,  
    cardname: 'guide',  
    subTitle: '',  
    title: t('tutorial'),  
    descTop: '',  
    descBottom: '',  
    details: [  
      {  
        name: t('tutorial_connect'),  
        desc: '',  
        img: TutorialMainnet,  
        link: t('tutorial_connect_link'),  
      },  
      {  
        name: t('tutorial_farming'),  
        desc: '',  
        img: TutorialFarming,  
        link: t('tutorial_farming_link'),  
      },  
    ],  
    caption: '',  
  };  
  
  const CardWithHeader = ({ cardWithHeader }) => (  
    <div id={cardWithHeader.cardname} className={`portal-header-frame type-${cardWithHeader.type} card-${cardWithHeader.cardname}`}>  
      <div className="portal-frame">  
        <div className="sub-title text-center">{cardWithHeader.subTitle}</div>  
        <div className="title text-center">{cardWithHeader.title}</div>  
  
        <div className="text-desc-top text-center">{cardWithHeader.descTop}</div>  
        <div className="text-desc-bottom text-center">{cardWithHeader.descBottom}</div>  
  
  
        <div className="cards flex flex-wrap justify-center -mx">  
          {cardWithHeader.details.map((card, index) => (  
            <div key={index} className={  
              cardWithHeader.cardname === 'game'  
                ? 'w-1/2 md:w-1/3 px-3'  
                : cardWithHeader.cardname === 'guide'  
                  ? 'w-full md:w-1/2 px-3'  
                  : cardWithHeader.cardname === 'ecosystem'  
                    ? 'w-1/2 md:w-1/4 xl:w-1/6'  
                    : 'w-1/2 md:w-1/3 lg:w-1/3 px-3'  
            }>  
              <div className="box small" rel="noopener noreferrer">  
                <a className="box-thumb" href={card.link} target="_blank" rel="noreferrer noopener">  
                  <img src={card.img} alt="" className="" />  
                </a>  
                {cardWithHeader.cardname === 'guide' ? (  
                  <div className="box-desc">  
                    <a className="title" href={card.link} target="_blank" rel="noreferrer noopener">{card.name}</a>  
                    {card.languages != null && (  
                      <div className='languages flex flex-wrap'>  
                        {card.languages.map((lang, langIndex) => (  
                          <a href={lang.link} className='language border-solid border-2 border-white me-2 mb-2 px-2' key={langIndex}>  
                            {lang.lang}  
                          </a>  
                        ))}  
                      </div>  
                    )}  
                  </div>  
                ) : (  
                  <a className="box-desc" href={card.link} target="_blank" rel="noreferrer noopener">  
                    <div className="title">{card.name}</div>  
                    <div className="sub-title">{card.desc}</div>  
                  </a>  
                )}  
              </div>  
            </div>  
          ))}  
        </div>  
        {cardWithHeader.type === 2 && (<div className="caption flex text-center justify-center">{cardWithHeader.caption}</div>)}  
      </div>  
    </div>  
  );  
  
  return (  
    <main className="home font-normal leading-7">  
      <div className="container m-auto">  
        <div className="heading">  
          <h1 className="mb-5 md:mb-4">ZKcandy <span>{t('mainnet')}<br /> {t('live')}</span></h1>  
          <p>{t('description')}</p>  
  
          {/* Updated Total Wallets section with animation */}  
          {totalWallets !== null && (  
            <div className="flex justify-center mt-20">  
              <div className="total-wallets-frame mt-10 w-[700px] flex flex-col items-center">  
                <div className="total-wallets-bg relative flex items-center">  
                  <img className='total-wallet-header w-[70%] -top-[30%] xl:-top-[35%]' src={CounterTitle} alt={t('total_wallets')} />  
                  <img className='h-[100%] absolute right-[78%]' src={CounterFrameLeft} alt={t('total_wallets')} />  
                  <img className='h-[100%] absolute left-[85%]' src={CounterFrameRight} alt={t('total_wallets')} />  
  
                  <div className="total-wallets-count">  
                    <div className="text relative z-10">  
                      <AnimatedNumber n={totalWallets} />  
                    </div>  
                    <div className="text-bg">  
                      <AnimatedNumber n={totalWallets} />  
                    </div>  
                  </div>  
                </div>  
              </div>  
            </div>  
          )}  
          <div className='network-status text-center max-w-[500px] w-[90%] mx-auto font-montserrat -mt-5'>  
            <div className='text-white font-bold md:text-[1rem] text-[.8rem]'>  
              {t('network_status')}: <span className='text-[#00FF2F]'>{t('online')}</span>  
            </div>  
          </div>  
  
          <div className="spaceships">  
            <div className="flex justify-between items-center">  
              <div className="flex items-center">  
                <img  
                  src={Spaceship1}  
                  alt="spaceship"  
                  className="spaceship-1"  
                />  
                <img  
                  src={Spaceship2}  
                  alt="spaceship"  
                  className="spaceship-2"  
                />  
              </div>  
              <div className="flex items-center">  
                <img  
                  src={Spaceship3}  
                  alt="spaceship"  
                  className="spaceship-3"  
                />  
                <img  
                  src={Spaceship1}  
                  alt="spaceship"  
                  className="spaceship-4"  
                />  
              </div>  
            </div>  
          </div>  
        </div>  
  
        <Quickstart />  
  
        <div className="menu-container space-y-20">  
          <div id="tools" className={`portal-header-frame type-1 card-tools`}>  
            <div className="portal-frame">  
              <div className="title text-center">{t('tools')}</div>  
              <div className="text-desc-bottom text-center mt-5">{t('tools_desc')}</div>  
              <div className="cards flex flex-wrap justify-center -mx">  
                {toolsContent.details.map((card, index) => (  
                  <div key={index} className="w-1/2 md:w-1/4 px-3">  
                    <div className="box small" rel="noopener noreferrer">  
                      <a className="box-thumb" href={card.link} target="_blank" rel="noreferrer noopener">  
                        <img src={card.img} alt="" className="" />  
                      </a>  
                      <a className="box-desc" href={card.link} target="_blank" rel="noreferrer noopener">  
                        <div className="title">{t(card.name.toLowerCase())}</div>  
                        <div className="sub-title">{t(`${card.name.toLowerCase()}_desc`)}</div>  
                      </a>  
                    </div>  
                  </div>  
                ))}  
                <div className="w-1/2 md:w-1/4 px-3">  
                  <div className="box small" rel="noopener noreferrer" onClick={connectWallet}>  
                    <div className="box-thumb">  
                      <img src={MenuConnect} alt={t('connect')} />  
                    </div>  
                    <div className="box-desc">  
                      <div className="title">{t('connect')}</div>  
                      <div className="sub-title">{t('connect_desc')}</div>  
                    </div>  
                  </div>  
                </div>  
              </div>  
            </div>  
          </div>  
  
          <div className="hover:translate-y-[-4px]  transition duration-100  hover:shadow-[10px_10px_0_#291051] rounded-[1rem]">  
            <Swiper  
              slidesPerView={1}  
              spaceBetween={30}  
              loop={true}  
              navigation={true}  
              modules={[Autoplay, Navigation]}  
              autoplay={{  
                delay: 5000,  
                disableOnInteraction: false,  
              }}  
              className="mySwiper"  
            >  
              <SwiperSlide>  
                <a href="https://kroswap.zkcandy.io/" target="_blank" rel="noopener noreferrer">  
                  <img src={SwipeBanner1} alt="KRO Swap" className='rounded-[1rem] border-2 border-[#ffffff80] w-full' />  
                </a>  
              </SwiperSlide>  
              <SwiperSlide>  
                <a href="https://app.layer3.xyz/campaigns/zkcandy" target="_blank" rel="noopener noreferrer">  
                  <img src={SwipeBanner2} alt="Layer 3" className='rounded-[1rem] border-2 border-[#ffffff80] w-full' />  
                </a>  
              </SwiperSlide>  
            </Swiper>  
          </div>  
  
          <div className="flex gap-2 flex-col md:flex-row font-montserrat text-center">  
            <div className="box-dot-container p-10 relative w-full md:w-2/3 mb-5 md:mb-0 flex flex-col justify-center items-center">  
              <div className="dot absolute top-4 left-4"></div>  
              <div className="dot absolute top-4 right-4"></div>  
              <div className="dot absolute bottom-4 left-4"></div>  
              <div className="dot absolute bottom-4 right-4"></div>  
              <div  
                className='uppercase text-center font-black text-[1.5rem] md:text-[2rem] lg:text-[3rem] mb-5 leading-[1]'  
                dangerouslySetInnerHTML={{  
                  __html: t('convenience').replace(/\n/g, '<br />'),  
                }}  
              />  
              <div className="lg:text-[1.5rem]" dangerouslySetInnerHTML={{  
                __html: t('explore_mainnet').replace(/\n/g, '<br />'),  
              }} />  
  
              <div className="flex justify-center mt-5">  
                <a href='https://t.me/zkcandygame_bot' target='_blank' rel="noreferrer" className='max-w-[320px] bg-[#FD00CA] text-black font-black uppercase rounded-2xl border-black border-2 shadow-[0_10px_0_#390260] px-6 py-4 text-[1.2rem] xl:text-[1.5rem] relative hover:text-white transition duration-300  hover:shadow-[0_0px_8px_#FFF] hover:translate-y-[10px]'>  
                  <div className="dot white absolute top-2 left-2 scale-50"></div>  
                  <div className="dot white absolute bottom-2 left-2 scale-50"></div>  
                  <div className="dot white absolute top-2 right-2 scale-50"></div>  
                  <div className="dot white absolute bottom-2 right-2 scale-50"></div>  
                  {t('enter_game_center')}  
                </a>  
              </div>  
            </div>  
            <div className="box-dot-container no-padding mb-5 md:mb-0  w-full md:w-1/3">  
              <img src={PartnerGamecenter} alt="Gamecenter" className="p-3" />  
            </div>  
          </div>  
  
          <CardWithHeader cardWithHeader={guideContent} />  
  
          <div className="flex justify-center">  
            <Link to="/login" className="button-voyage text-center bg-[#FFCC5A] text-[#481C8E] border-2 border-[#481C8E] rounded-xl p-4 shadow-[6px_6px_0_#8132ff] hover:translate-y-[-4px] hover:shadow-[10px_10px_0_#8132ff] transition duration-100">{t('tutorial_voyage')}</Link>  
          </div>  
  
          <Faq />  
        </div>  
      </div>  
    </main>  
  );  
}  